import { PERMISSOES } from './permissoes.catalog';
import { PermissionRef, toRole } from './permission.model';

/** PermissionRef-folha: objeto cujo `modulo` é string (distingue do grupo aninhado, cujo `modulo` é objeto). */
function isPermissionRef(v: unknown): v is PermissionRef {
    return typeof v === 'object' && v !== null && typeof (v as PermissionRef).modulo === 'string';
}

function coletar(node: unknown, acc: Set<string>): void {
    if (typeof node === 'string') {
        acc.add(node);
        return;
    }
    if (isPermissionRef(node)) {
        if (node.acao) acc.add(toRole(node)); // só roles completas; refs de escopo (sem ação) ficam de fora
        return;
    }
    if (node && typeof node === 'object') {
        for (const v of Object.values(node)) coletar(v, acc);
    }
}

/** Roles COMPLETAS do catálogo (strings literais + PermissionRef com `acao`), ordenadas e sem duplicatas. */
export function flattenCatalogo(): string[] {
    const acc = new Set<string>();
    coletar(PERMISSOES, acc);
    return [...acc].sort();
}
